import { send } from '../../../src/network';
import { type PairingV1 } from '../../../src/types/PairingV1';

export type PagedRecipes = {
  dish_type_count: { [name: number]: number };
  pairings: PairingV1[];
  total_count: number;
};

export interface SwappableParamsResponse {
  pairings: unknown[];
  swappable_pairings: Record<string, PairingV1[]>;
}

export const FILTER_PAIRINGS_PATH = '/api/filter_pairings/';

export async function getFilterPairings(query: URLSearchParams) {
  return send<SwappableParamsResponse | unknown>({
    method: 'GET',
    path: FILTER_PAIRINGS_PATH,
    query,
  });
}
